import * as CryptoJS from 'crypto-js';

const enabled = window.reactGlobals && window.reactGlobals.shield ? window.reactGlobals.shield.enabled : "";
const iterationCount = window.reactGlobals && window.reactGlobals.shield ? parseInt(window.reactGlobals.shield.ic) : "";
const keySize = window.reactGlobals && window.reactGlobals.shield ? parseInt(window.reactGlobals.shield.kz) : "";
const encryptionKey = window.reactGlobals && window.reactGlobals.shield ? window.reactGlobals.shield.oe : "";
const iv = window.reactGlobals && window.reactGlobals.shield ? window.reactGlobals.shield.vq : "";
const salt = window.reactGlobals && window.reactGlobals.shield ? window.reactGlobals.shield.sz : "";


const generateKey = (salt, encryptionKey, keySize, iterationCount) => {
  let keyInfo = keySize / 32;
  let key = CryptoJS.PBKDF2(encryptionKey, CryptoJS.enc.Hex.parse(salt),
    { keySize: keyInfo, iterations: iterationCount });
  return key;
}

const key = generateKey(salt, encryptionKey, keySize, iterationCount);
const ivParsed = CryptoJS.enc.Hex.parse(iv);

export const encryptData = (plainText) => {
  const encrypt = (plainText) => {
    let encrypted = CryptoJS.AES.encrypt(plainText, key, { iv: ivParsed });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }
  let encryptedText = plainText;
  try {
    if ("N" === enabled) {
      return plainText;
    }
    encryptedText = encrypt(plainText);
    if (null === encryptedText || encryptedText.trim().length === 0) {
      //send back the original, if it is empty after conversion.
      encryptedText = plainText;
    }
  }
  catch (e) {
    //send back the original, if any errors during conversion.
    encryptedText = plainText;
  } 
  
  return encryptedText;

}

export const decryptData = (cipherText) => {
  const decrypt = (cipherText) => {
    let cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText)
    });
    let decrypted = CryptoJS.AES.decrypt(cipherParams, key, { iv: ivParsed });
    
    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  let plainText = cipherText;
  try {
    if ("N" === enabled) {
      return plainText;
    }

    plainText = decrypt(cipherText);
    if (null === plainText || plainText.trim().length === 0) {
      //send back the original, if it is empty after conversion.
      plainText = cipherText;
    }
  }
  catch (e) {
    //send back the original, if any errors during conversion.
    plainText = cipherText;
  }

  return plainText;
}
